(function () {
  'use strict';

  function t26ParseKstDateTime(t26Value) {
    var t26Match = String(t26Value || '')
      .trim()
      .match(/^(\d{4})-(\d{2})-(\d{2})[ T](\d{2}):(\d{2})(?::(\d{2}))?$/);

    if (!t26Match) {
      return NaN;
    }

    return Date.parse(
      t26Match[1] +
        '-' +
        t26Match[2] +
        '-' +
        t26Match[3] +
        'T' +
        t26Match[4] +
        ':' +
        t26Match[5] +
        ':' +
        (t26Match[6] || '00') +
        '+09:00',
    );
  }

  function t26PadCountdownValue(t26Value) {
    return String(t26Value).padStart(2, '0');
  }

  function t26InitializeCountdown(t26Section) {
    var t26Countdown = t26Section.querySelector('[data-t26-countdown]');

    if (!t26Countdown || t26Countdown.getAttribute('data-t26-countdown-initialized') === 'true') {
      return;
    }

    var t26EndAt = t26ParseKstDateTime(t26Countdown.getAttribute('data-t26-countdown-end'));

    if (Number.isNaN(t26EndAt)) {
      t26Countdown.hidden = true;
      return;
    }

    var t26Clock = t26Countdown.querySelector('[data-t26-countdown-clock]');
    var t26Days = t26Countdown.querySelector('[data-t26-countdown-days]');
    var t26Hours = t26Countdown.querySelector('[data-t26-countdown-hours]');
    var t26Minutes = t26Countdown.querySelector('[data-t26-countdown-minutes]');
    var t26Seconds = t26Countdown.querySelector('[data-t26-countdown-seconds]');
    var t26Deadline = t26Countdown.querySelector('[data-t26-countdown-deadline]');
    var t26Expired = t26Countdown.querySelector('[data-t26-countdown-expired]');
    var t26Interval = null;
    var t26FormattedDeadline = new Intl.DateTimeFormat('en-US', {
      timeZone: 'Asia/Seoul',
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      hour: 'numeric',
      minute: '2-digit',
    }).format(new Date(t26EndAt));

    t26Deadline.textContent = 'Offer ends ' + t26FormattedDeadline + ' KST';
    t26Countdown.setAttribute('data-t26-countdown-initialized', 'true');

    function t26UpdateCountdown() {
      if (!t26Countdown.isConnected) {
        if (t26Interval !== null) {
          window.clearInterval(t26Interval);
        }
        return;
      }

      var t26Remaining = t26EndAt - Date.now();

      if (t26Remaining <= 0) {
        t26Clock.hidden = true;
        t26Deadline.hidden = true;
        t26Expired.textContent =
          t26Countdown.getAttribute('data-t26-countdown-expired-text') || 'This special offer has ended.';
        t26Expired.hidden = false;

        if (t26Interval !== null) {
          window.clearInterval(t26Interval);
        }
        return;
      }

      var t26Day = 24 * 60 * 60 * 1000;
      var t26Hour = 60 * 60 * 1000;
      var t26Minute = 60 * 1000;

      t26Days.textContent = t26PadCountdownValue(Math.floor(t26Remaining / t26Day));
      t26Hours.textContent = t26PadCountdownValue(Math.floor((t26Remaining % t26Day) / t26Hour));
      t26Minutes.textContent = t26PadCountdownValue(Math.floor((t26Remaining % t26Hour) / t26Minute));
      t26Seconds.textContent = t26PadCountdownValue(Math.floor((t26Remaining % t26Minute) / 1000));
    }

    t26UpdateCountdown();

    if (Date.now() < t26EndAt) {
      t26Interval = window.setInterval(t26UpdateCountdown, 1000);
    }
  }

  function t26InitializeHomePromotions(t26Root) {
    var t26Scope = t26Root || document;
    var t26Sections = t26Scope.matches && t26Scope.matches('[data-t26-home-promotions]')
      ? [t26Scope]
      : t26Scope.querySelectorAll('[data-t26-home-promotions]');

    t26Sections.forEach(function (t26Section) {
      t26InitializeCountdown(t26Section);

      if (t26Section.getAttribute('data-t26-initialized') === 'true') {
        return;
      }

      var t26Dialogs = t26Section.querySelectorAll('[data-t26-dialog]');
      var t26OpenButtons = t26Section.querySelectorAll('[data-t26-dialog-open]');

      t26OpenButtons.forEach(function (t26Button) {
        t26Button.addEventListener('click', function () {
          var t26DialogId = t26Button.getAttribute('aria-controls');
          var t26Dialog = t26DialogId ? document.getElementById(t26DialogId) : null;

          if (!t26Dialog || !t26Section.contains(t26Dialog) || typeof t26Dialog.showModal !== 'function') {
            return;
          }

          t26Dialog.t26LastTrigger = t26Button;
          t26Dialog.showModal();
        });
      });

      t26Dialogs.forEach(function (t26Dialog) {
        t26Dialog.addEventListener('click', function (t26Event) {
          if (t26Event.target === t26Dialog) {
            t26Dialog.close();
          }
        });

        t26Dialog.addEventListener('close', function () {
          if (t26Dialog.t26LastTrigger) {
            t26Dialog.t26LastTrigger.focus();
          }
        });
      });

      t26Section.setAttribute('data-t26-initialized', 'true');
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      t26InitializeHomePromotions(document);
    });
  } else {
    t26InitializeHomePromotions(document);
  }

  document.addEventListener('shopify:section:load', function (t26Event) {
    t26InitializeHomePromotions(t26Event.target);
  });
})();
